import {merge} from 'lodash';
import {AppConfig} from './app.config-definition';
import {APP_CONFIGURATIONS} from './app.config-default';

export function initConfigurations(config: AppConfig) {
    /* Disable overriding from server configs*/
    // delete config.isProduction;

    if (!APP_CONFIGURATIONS.$$init) {
        /* lodash merge for deep merging */
        merge(APP_CONFIGURATIONS, config);

        // Migrating current settings to new config object
        // FIXME mikhail - Remove after config migration
        if (!!APP_CONFIGURATIONS.newAccountCreationUrl) {
            APP_CONFIGURATIONS.newAccountButton.enabled = true;
            APP_CONFIGURATIONS.newAccountButton.url = APP_CONFIGURATIONS.newAccountCreationUrl;
        }

        APP_CONFIGURATIONS.$$init = true;
    } else {
        console.error('Re-initialize the configuration!');
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/config/app.config-init.ts